import { render, staticRenderFns } from "./ObiNav.vue?vue&type=template&id=65fd9806&scoped=true&"
import script from "./ObiNav.vue?vue&type=script&lang=js&"
export * from "./ObiNav.vue?vue&type=script&lang=js&"
import style0 from "./ObiNav.vue?vue&type=style&index=0&id=65fd9806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd9806",
  null
  
)

export default component.exports